<div
  class="search-bar content-margin"
  [class.search-tooltips-muted]="locationSelect.panelOpen || floorSelect.panelOpen || !!dateDropdown?.isOpen"
>
  <div class="booking-row">
    <div class="booking-label">Book for</div>
    <mat-form-field class="booking-pill booking-pill-field" appearance="outline">
      <mat-select
        #bookingForSelect="matSelect"
        [value]="selectedBookingForId"
        (valueChange)="onBookingForChange($event)"
        (openedChange)="onBookingForPanelOpenChange($event)"
        aria-label="Booking For"
        panelClass="booking-for-panel"
      >
        <mat-select-trigger>
          <span class="booking-trigger">
            <span class="booking-value">{{ bookingForText }}</span>
            <span
              class="filter-arrow booking-for-arrow"
              [class.filter-arrow-open]="bookingForSelect.panelOpen"
              aria-hidden="true"
            ></span>
          </span>
        </mat-select-trigger>

        <mat-option class="booking-for-search-option">
          <ngx-mat-select-search
            [ariaLabel]="'Search for user'"
            [formControl]="bookingForSearchControl"
            [placeholderLabel]="'Search'"
            [clearSearchInput]="false"
            [noEntriesFoundLabel]="bookingForNoEntriesLabel"
            (keydown.enter)="onBookingForSearchEnter($event, bookingForSelect)"
          >
          </ngx-mat-select-search>
        </mat-option>

        <mat-option
          *ngIf="needsSelectedBookingForGhostOption"
          class="booking-for-hidden-selected-option"
          [value]="selectedBookingForId"
          aria-hidden="true"
        >
          {{ selectedBookingForLabel || bookingForText }}
        </mat-option>

        <mat-option *ngFor="let bookingFor of sortedBookingForOptions" [value]="bookingFor.id">
          {{ bookingForOptionText(bookingFor) }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="filters-row">
    <div
      class="filter-col with-divider location-col"
      [class.autofill-in-progress]="autofillInProgress"
      [matTooltip]="autofillInProgress ? 'Pre-filling your last booking details...' : ''"
      [matTooltipDisabled]="!autofillInProgress"
      matTooltipClass="autofill-inline-tooltip"
      matTooltipPosition="above"
    >
      <mat-form-field
        class="quick-select-field"
        [class.control-invalid]="searchErrors.locationError"
        appearance="outline"
      >
        <mat-select
          #locationSelect="matSelect"
          [value]="selectedLocationId"
          (valueChange)="onLocationSelectionChange($event)"
          [disabled]="isLocationDisabled"
          aria-label="Location"
          [attr.aria-invalid]="showValidation && searchErrors.locationError ? 'true' : null"
          [attr.aria-describedby]="showValidation && searchErrors.locationError ? 'location-error' : null"
          panelClass="location-panel"
        >
          <mat-select-trigger>
            <div class="quick-select-trigger">
              <mat-icon
                *ngIf="locationText"
                svgIcon="ontario:pin-location-on"
                class="quick-select-icon"
                aria-hidden="true"
              ></mat-icon>
              <div *ngIf="locationText" class="quick-select-copy quick-select-copy-empty">
                <div class="quick-select-label">Location</div>
                <div class="quick-select-value" [class.field-placeholder]="isLocationEmpty">{{ locationText }}</div>
              </div>
              <span
                *ngIf="locationText"
                class="filter-arrow"
                [class.filter-arrow-open]="locationSelect.panelOpen"
                aria-hidden="true"
              ></span>
            </div>
          </mat-select-trigger>
          <mat-option class="location-placeholder-option" [value]="-1">Select location</mat-option>
          <mat-option *ngFor="let option of locations" [value]="option.id">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="!locationText" class="location-empty-fallback" aria-hidden="true">
        <mat-icon svgIcon="ontario:pin-location-on" class="quick-select-icon" aria-hidden="true"></mat-icon>
        <div class="quick-select-copy quick-select-copy-empty">
          <div class="quick-select-label">Location</div>
        </div>
        <span class="filter-arrow" aria-hidden="true"></span>
      </div>

      <div *ngIf="showValidation && searchErrors.locationError" class="field-tooltip-stack">
        <app-error-tooltip class="field-error-tooltip" tooltipId="location-error">Select a location</app-error-tooltip>
      </div>
    </div>

    <div class="filter-col with-divider date-col">
      <app-filter-dropdown
        #dateDropdown
        label="Date"
        [valueText]="dateText"
        [dimValue]="isDateEmpty"
        ariaLabel="Date"
        [ariaDescribedBy]="dateSummaryErrorIds"
        iconSvg="ontario:calendar"
        [panelWidth]="300"
        panelClass="date-dropdown-panel"
        [invalid]="showValidation && hasDateErrors"
      >
        <div class="date-menu">
          <div class="date-menu-section">
            <div class="date-menu-label">Start date</div>
            <div class="date-menu-field-anchor">
              <mat-form-field
                class="menu-field date-menu-field"
                [class.control-invalid]="searchErrors.startDateError"
                appearance="outline"
                (click)="openDatepicker(datePicker)"
              >
                <input
                  matInput
                  [matDatepicker]="datePicker"
                  [(ngModel)]="selectedStartDate"
                  placeholder="Select a start date"
                  [matDatepickerFilter]="weekdayFilter"
                  [min]="minDate"
                  [max]="maxDate"
                  aria-label="Start date"
                  [attr.aria-invalid]="showValidation && searchErrors.startDateError ? 'true' : null"
                  [attr.aria-describedby]="showValidation && searchErrors.startDateError ? 'start-date-error' : null"
                  readonly
                  (click)="openDatepicker(datePicker)"
                  (keydown.enter)="openDatepickerOnEnter($event, datePicker)"
                  (dateChange)="onStartDateChanged()"
                />
                <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                <mat-datepicker #datePicker></mat-datepicker>
              </mat-form-field>

              <div
                *ngIf="showValidation && searchErrors.startDateError"
                class="date-menu-error-stack date-menu-error-stack-above-line"
              >
                <app-error-tooltip class="date-menu-error-tooltip" tooltipId="start-date-error"
                  >Select a valid start date</app-error-tooltip
                >
              </div>
            </div>
          </div>

          <div class="date-menu-section" [style.opacity]="autofillInProgress ? 0.8 : 1">
            <div class="date-menu-label" [style.opacity]="autofillInProgress ? 0.8 : 1">Time Period</div>
            <div class="date-menu-field-anchor">
              <mat-form-field
                class="menu-field date-menu-field"
                [class.control-invalid]="searchErrors.periodError"
                [class.autofill-in-progress]="autofillInProgress"
                [matTooltip]="autofillInProgress ? 'Pre-filling your last booking details...' : ''"
                [matTooltipDisabled]="!autofillInProgress"
                matTooltipClass="autofill-inline-tooltip"
                matTooltipPosition="above"
                appearance="outline"
              >
                <mat-select
                  [(value)]="selectedPeriodId"
                  (valueChange)="onPeriodChanged()"
                  [style.opacity]="autofillInProgress ? 0.8 : 1"
                  [disabled]="isTimePeriodDisabled"
                  placeholder="Select a time period"
                  aria-label="Time Period"
                  [attr.aria-invalid]="showValidation && searchErrors.periodError ? 'true' : null"
                  [attr.aria-describedby]="showValidation && searchErrors.periodError ? 'period-error' : null"
                >
                  <mat-option *ngFor="let period of timePeriods" [value]="period.id">
                    {{ period.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div
                *ngIf="showValidation && searchErrors.periodError"
                class="date-menu-error-stack date-menu-error-stack-above-line"
              >
                <app-error-tooltip class="date-menu-error-tooltip" tooltipId="period-error"
                  >Select a time period</app-error-tooltip
                >
              </div>
            </div>
          </div>

          <div
            class="repeat-row date-repeat-row"
            [class.repeat-enabled]="repeatEnabled"
            [style.cursor]="repeatDisabled ? 'not-allowed' : 'default'"
            [matTooltip]="repeatDisabled ? 'Repeat is disabled for OTC floors' : 'Select to enable recurrence pattern'"
          >
            <div class="repeat-copy date-repeat-copy" [style.opacity]="repeatDisabled ? 0.5 : 1">
              <span class="repeat-icon-wrap">
                <mat-icon class="repeat-icon" aria-hidden="true">autorenew</mat-icon>
              </span>
              <span>Repeat</span>
            </div>
            <mat-slide-toggle
              color="primary"
              [checked]="repeatEnabled"
              aria-label="Repeat"
              [disabled]="repeatDisabled"
              [style.opacity]="repeatDisabled ? 0.5 : 1"
              [style.cursor]="repeatDisabled ? 'not-allowed' : 'default'"
              (change)="onRepeatChange($event.checked)"
            ></mat-slide-toggle>
          </div>

          <div *ngIf="repeatEnabled" class="date-repeat-days-block">
            <div class="date-repeat-days-anchor">
              <div
                class="day-pill-row date-day-pill-row"
                role="group"
                aria-label="Recurrence days"
                [attr.aria-invalid]="
                  showValidation && (searchErrors.repeatDaysError || searchErrors.repeatRangeError) ? 'true' : null
                "
                [attr.aria-describedby]="repeatErrorsDescribedBy"
              >
                <button
                  type="button"
                  *ngFor="let day of weekdays"
                  class="day-pill date-day-pill"
                  [class.day-pill-active]="isDayActive(day)"
                  [class.day-pill-invalid]="searchErrors.repeatDaysError"
                  [attr.aria-pressed]="isDayActive(day)"
                  (click)="toggleDay(day)"
                >
                  {{ getWeekdayLabel(day) }}
                </button>
              </div>

              <div *ngIf="showValidation && searchErrors.repeatDaysError" class="date-menu-error-stack">
                <app-error-tooltip class="date-menu-error-tooltip" tooltipId="repeat-days-error"
                  >Select at least one recurrence day</app-error-tooltip
                >
              </div>

              <div *ngIf="showValidation && searchErrors.repeatRangeError" class="date-menu-error-stack">
                <app-error-tooltip class="date-menu-error-tooltip" tooltipId="repeat-range-error">
                  The reservation does not contain any valid dates
                </app-error-tooltip>
              </div>
            </div>
          </div>

          <div *ngIf="repeatEnabled" class="date-menu-section">
            <div class="date-menu-label">End Date</div>
            <div class="date-menu-field-anchor">
              <mat-form-field
                class="menu-field date-menu-field date-menu-field-end"
                [class.control-invalid]="searchErrors.endDateError || searchErrors.endBeforeStartError"
                appearance="outline"
                (click)="openDatepicker(endDatePicker)"
              >
                <input
                  matInput
                  [matDatepicker]="endDatePicker"
                  [(ngModel)]="selectedEndDate"
                  placeholder="Select an end date"
                  [min]="selectedStartDate"
                  [max]="maxDate"
                  [matDatepickerFilter]="weekdayFilter"
                  aria-label="End date"
                  [attr.aria-invalid]="
                    showValidation && (searchErrors.endDateError || searchErrors.endBeforeStartError) ? 'true' : null
                  "
                  [attr.aria-describedby]="endDateErrorDescribedBy"
                  readonly
                  (click)="openDatepicker(endDatePicker)"
                  (keydown.enter)="openDatepickerOnEnter($event, endDatePicker)"
                  (dateChange)="onEndDateChanged()"
                />
                <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #endDatePicker></mat-datepicker>
              </mat-form-field>

              <div
                *ngIf="showValidation && (searchErrors.endDateError || searchErrors.endBeforeStartError)"
                class="date-menu-error-stack date-menu-error-stack-above-line"
              >
                <app-error-tooltip
                  *ngIf="searchErrors.endDateError"
                  class="date-menu-error-tooltip"
                  tooltipId="end-date-error"
                >
                  Select a valid end date
                </app-error-tooltip>

                <app-error-tooltip
                  *ngIf="searchErrors.endBeforeStartError"
                  class="date-menu-error-tooltip"
                  tooltipId="end-before-start-error"
                >
                  End date cannot be before start date
                </app-error-tooltip>
              </div>
            </div>
          </div>
        </div>
      </app-filter-dropdown>

      <div *ngIf="showValidation && hasDateErrors" class="date-tooltip-stack">
        <app-error-tooltip
          *ngFor="let message of dateValidationMessages; let i = index"
          class="date-error-tooltip"
          [tooltipId]="'date-summary-error-' + i"
        >
          {{ message }}
        </app-error-tooltip>
      </div>
    </div>

    <div
      class="filter-col with-divider floors-col"
      [class.autofill-in-progress]="autofillInProgress"
      [class.floors-unavailable]="selectedLocationId === -1"
      [matTooltip]="autofillInProgress ? 'Pre-filling your last booking details...' : 'Select a location first'"
      [matTooltipDisabled]="autofillInProgress ? false : selectedLocationId !== -1"
      matTooltipClass="autofill-inline-tooltip"
      matTooltipPosition="above"
    >
      <mat-form-field
        class="quick-select-field"
        [class.control-invalid]="searchErrors.floorsError"
        appearance="outline"
      >
        <mat-select
          #floorSelect="matSelect"
          [value]="selectedFloorIds"
          (valueChange)="onFloorSelectionChange($event)"
          aria-label="Floors"
          [attr.aria-invalid]="showValidation && searchErrors.floorsError ? 'true' : null"
          [attr.aria-describedby]="showValidation && searchErrors.floorsError ? 'floors-error' : null"
          [disabled]="isFloorsDisabled"
          panelClass="floors-panel"
          multiple
        >
          <mat-select-trigger>
            <div class="quick-select-trigger quick-select-trigger-floors">
              <div class="quick-select-copy quick-select-copy-empty">
                <div class="quick-select-label">Floor(s)</div>
                <div class="quick-select-value" [class.field-placeholder]="isFloorEmpty">{{ floorText }}</div>
              </div>
              <span class="filter-arrow" [class.filter-arrow-open]="floorSelect.panelOpen" aria-hidden="true"></span>
            </div>
          </mat-select-trigger>
          <mat-option class="floor-placeholder-option" [value]="-1">Select floors</mat-option>
          <mat-option *ngFor="let floor of floors" [value]="floor.id">
            {{ floor.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="showValidation && searchErrors.floorsError" class="field-tooltip-stack">
        <app-error-tooltip class="field-error-tooltip" tooltipId="floors-error"
          >Select at least one floor</app-error-tooltip
        >
      </div>
    </div>

    <button
      type="button"
      class="ontario-button ontario-button--primary search-button"
      (pointerdown)="onSearchButtonPointerDown($event)"
      (click)="onSearchClick()"
    >
      <mat-icon svgIcon="ontario:search" class="search-icon" aria-hidden="true"></mat-icon>
      <span class="search-text">Search</span>
    </button>
  </div>
</div>
